import "../css/CommonDesign.css";
import icon_hatena_gray from "../images/hatena_gray.svg";
import React, { useState, useEffect, createContext, useContext, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Autocomplete, TextField, Table, TableBody, TableCell, TableHead, TableRow, Button, FormControl, FormHelperText, Chip, Backdrop, CircularProgress } from "@mui/material";
import { debounce } from "lodash";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import icon_bikkuri from "../images/bikkuri.svg";

import ExportCountryDialog from "./dialog/ExportCountryDialog";
import ProductDialog from "./dialog/ProductDialog";
import { API, ENV, SET_ENV } from "./constantsFront";
import { MsgContext } from "../../App";
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import parse from 'html-react-parser';
import MenuMenu from "./MenuMenu";
import { textAlign } from "@mui/system";
import { gridColumnGroupsLookupSelector, renderActionsCell } from "@mui/x-data-grid";
import { compIconConversion, dataJudge, priorityJudge, PriorityJudgePlantRadio } from "./D001Common";
import { Margin } from "@mui/icons-material";

export const CountryContext = createContext();
export const ProductContext = createContext();

/**
 * 検索TOP
 * @returns 
 */
function D001SearchTop() {
  const navigate = useNavigate();

  // よく見られる品目ボタンリスト
  const [seenProductList, setSeenProductList] = useState([]);
  const [hideProductList, setHideProductList] = useState([]);
  // よく見られる輸出先国ボタンリスト
  const [seenCountryList, setSeenCountryList] = useState([]);
  const [hideCountryList, setHideCountryList] = useState([]);

  // hideリストオープン
  const [isProductOpen, setIsProductOpen] = useState(false);
  const [isCountryOpen, setIsCountryOpen] = useState(false);

  // 前回のキーワード
  const [beforeProduct, setBeforeProduct] = useState("");
  const [beforeCountry, setBeforeCountry] = useState("");
  // 表示候補(本来はreduxのuseSelectorなんかでデータを管理する)
  const [productOptions, setProductOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  // 選択されている内容
  const [autocompleteProduct, setAutocompleteProduct] = useState([]);
  const [autocompleteCountry, setAutocompleteCountry] = useState([]);

  // 類似品目データ
  const [synProDataList, setSynProDataList] = useState([]);
  // const [synProData, setSynProData] = useState([]);
  let synProData = [];

  const note = (<div class="checkBorderBox">
    <div class="attention">本サイトで照会できるデータについて</div>
    {/* <p>当サイトは「農産物」、「水産物」・「加工食品等」の農林水産物の輸出に関する「植物検疫」「動物検疫」「放射性物質」「残留農薬」「食品添加物」の５つの規制について参照することができます。詳しくは「<Link to={"/D006FirstTime"}>初めての方へ</Link>」のページをご参照ください。</p> */}
    <p>本サイトは農産物、畜産物の輸出に関する「植物検疫」「動物検疫」「放射性物質」「残留農薬」「食品添加物」の５つの要件・規制について参照することができます。詳しくは上記タブの「<Link to={"/D006FirstTime"}>初めての⽅へ</Link>」と「<Link to={"/D007RoadMap"}>輸出要件・規制一覧</Link>」のページをご覧ください。</p>
  </div>);

  const [errorProduct, setErrorProduct] = useState(""); // 品目エラー


  const [isLoading, setIsLoading] = useState(false);  // Loading

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  // ダイアログ用
  const selectValue = {
    autocompleteProduct,
    setAutocompleteProduct,
    autocompleteCountry,
    setAutocompleteCountry,
  };

  // 輸出可否判定結果
  const [judge, setJudge] = useState([
    // <p class="judge">品目の輸出可・不可をチェック！</p>
    <p class="judge">植物検疫・動物検疫・放射性物質の要件・規制に対して輸出できるか簡易判定！</p>
  ]);

  // POSTデータ
  let body = { authKey: API.API_KEY };

  // 戻るボタンで戻った時の品目、国名を戻すための処理
  const location = useLocation();
  let dataList = [];
  let productName;
  if (location.state != null) {
    dataList = location.state.dataList;
    productName = location.state.productName;
  }

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  // 初期表示
  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    if (SET_ENV == ENV.ADMIN) {
      navigate("/G009AdminLogin");
    }
    displayHistory();

    // 戻るボタンで戻った時の品目、国名を戻すための処理
    if (location.state != null) {
      dataList = location.state.dataList;
      productName = location.state.productName;
      setAutocompleteProduct([{ product_name: productName, product_code: dataList[0].product_code }]);
      let countryCodeList = [];
      for (let i in dataList) {
        countryCodeList.push({ country_code: dataList[i].country_code, country_name: dataList[i].country_name });
      }
      setAutocompleteCountry(countryCodeList);
    }

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, [])

  // 履歴用
  function displayHistory() {
    // 品目履歴
    body.pageName = "輸出判定";
    body.type = 1;
    axios.post("/t_search_his/select", body).then(res => {
      let productHisList = res.data.dataList;

      // 品目履歴ボタン作成
      let seenProductList = [];
      let hideProductList = [];
      for (let i in productHisList) {
        if (i == 12) {
          // seenProductList.push(<p className="exceeded">・・・</p>);
          break;
        } else {
          let bg = "bg3";
          if (i < 2) {
            bg = "bg1";
          } else if (i < 4) {
            bg = "bg2";
          }
          let productHis = { product_code: productHisList[i].code, product_name: productHisList[i].name };
          if (i < 6) {
            seenProductList.push(
              <li
                class={bg}
                style={{ cursor: "pointer" }}
                onClick={(function (value) {
                  return async function () {
                    setAutocompleteProduct([productHis]);
                  }
                })(productHisList[i].name)}
              >
                <a>{productHisList[i].name}</a>
              </li>);
          } else {
            hideProductList.push(
              <li
                class={bg}
                style={{ cursor: "pointer" }}
                onClick={(function (value) {
                  return async function () {
                    setAutocompleteProduct([productHis]);
                  }
                })(productHisList[i].name)}
              >
                <a>{productHisList[i].name}</a>
              </li>);
          }
        }
      }
      setSeenProductList(seenProductList);
      setHideProductList(hideProductList);
    }).catch((err) => {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    });

    // 輸出先国履歴
    body.type = 2;
    axios.post("/t_search_his/select", body).then(res => {
      let counrtyHisList = res.data.dataList;

      // 輸出先国履歴ボタン作成
      let seenCountryList = [];
      let hideCountryList = [];
      for (let i in counrtyHisList) {
        if (i == 12) {
          // seenCountryList.push(<p className="exceeded">・・・</p>);
          break;
        } else {
          let bg = "bg3";
          if (i < 2) {
            bg = "bg1";
          } else if (i < 4) {
            bg = "bg2";
          }
          let countryHis = { country_code: counrtyHisList[i].code, country_name: counrtyHisList[i].name };
          if (i < 6) {
            seenCountryList.push(
              <li
                class={bg}
                style={{ cursor: "pointer" }}
                onClick={(function (value) {
                  return async function () {
                    setAutocompleteCountry([countryHis]);
                  }
                })(counrtyHisList[i].name)}
              >
                <a>{counrtyHisList[i].name}</a>
              </li>);
          } else {
            hideCountryList.push(
              <li
                class={bg}
                style={{ cursor: "pointer" }}
                onClick={(function (value) {
                  return async function () {
                    setAutocompleteCountry([countryHis]);
                  }
                })(counrtyHisList[i].name)}
              >
                <a>{counrtyHisList[i].name}</a>
              </li>);
          }
        }
      }
      setSeenCountryList(seenCountryList);
      setHideCountryList(hideCountryList);
    }).catch((err) => {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    });
  }

  // 変更が止まった後、指定時間(ミリ秒)後処理を行う
  const term = 200;
  const productSearchHandler = debounce(
    (changeValue) => productSearchMethod(changeValue),
    term
  );
  const countrySearchHandler = debounce(
    (changeValue) => countrySearchMethod(changeValue),
    term
  );

  // サジェスト用処理
  const productSearchMethod = async (changeValue) => {
    setBeforeProduct(changeValue);
    // 内容が同じ場合は処理しない
    if (changeValue.length > 0 && beforeProduct !== changeValue) {
      body.productName = changeValue;
      try {
        const res = await axios.post("/m_synonym_product/select", body);
        setProductOptions([...res.data.dataList]);
      } catch (err) {
        return setMsg("例外が発生しました。管理者にお問い合わせください。");
      }
    } else {
      // オートコンプリートの内容初期化
      setProductOptions([]);
    }
  };
  const countrySearchMethod = async (changeValue) => {
    try {
      setBeforeCountry(changeValue);
      // 内容が同じ場合は処理しない
      if (changeValue.length > 0 && beforeCountry !== changeValue) {
        body.countryName = changeValue;
        // const res = await axios.post("/m_export_country/select", body);
        // const res = await axios.post("/m_synonym_country/select", body);
        const res = await axios.post("/m_synonym_country/select/suggest", body);
        setCountryOptions([...res.data.dataList]);
      } else {
        // オートコンプリートの内容初期化
        setCountryOptions([]);
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  // 選択データが変わったときの処理
  const productChange = (event, selectedValue) => {
    // 選択されているオートコンプリート内容変更
    setAutocompleteProduct([...selectedValue]);
    // オートコンプリートの内容初期化
    setProductOptions([]);
  };
  const countryChange = (event, selectedValue) => {
    // 選択されているオートコンプリート内容変更
    setAutocompleteCountry([...selectedValue]);
    // オートコンプリートの内容初期化
    setCountryOptions([]);
  };

  // 輸出可否判定結果作成
  async function judgeMethod(dataList, productName, planNA, animalNA, radioNA, racNA, euNA, judgeMsg) {
    try {
      let judgeContent = [];
      let tableData = [];

      if (dataList.length != 0) {
        tableData = await setTableData(dataList, planNA, animalNA, radioNA, racNA, euNA);

        judgeContent.push(
          <div>
            <div class="checkTable div_hover"
              // 「詳細を見る」ボタン同様にクリックで詳細へ遷移する
              onClick={() => resultClick(dataList, productName)} style={{ cursor: "hand", cursor: "pointer" }}>
              {/* <div className="d001_item"> */}
              {/* <table bordercolor="darkgray"> */}
              {/* <tbody>{tableData}</tbody> */}
              {/* </table> */}
              {tableData}

            </div>
            {judgeMsg}
            {note}
            <div class="checkDetailBtn"><a onClick={() => resultClick(dataList, productName)}>詳細を見る</a></div>
          </div>
        );
      }

      setJudge(judgeContent);
      displayHistory();
      //  else {
      //   // setJudge([<div className="d001_item"><p>該当するデータが存在しませんでした</p></div>]);
      //   let judgeMsg = "「品目：" + hinmokuData.product_name + "」の該当データが見つかりませんでした。";
      //   setJudge([<p>{judgeMsg}{note}</p>]);
      // }
    } catch (err) {
      setIsLoading(false);
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  // テーブルのデータ作成
  async function setTableData(dataList, planNA, animalNA, radioNA, racNA, euNA) {
    let tableData = [];
    for (let i in dataList) {
      let countryName = dataList[i].country_name;
      let productCode = dataList[i].product_code;
      // 梱包
      let minPackingList = [];
      // 放射線データ取得
      let radioDataList = [];

      // 総合判定
      let compJudgeSentence = {
        icon: "", // 輸出可否コード
        supplement: "", // 補足文言
        // img: "",  //アイコンイメージ
      }
      // 植物判定
      let planSentence = {
        icon: "",
        supplement: "",
      }
      // 動物判定
      let animalSentence = {
        icon: "",
        supplement: "",
      }
      // 漁獲証明書判定
      let marineSentence = {
        icon: "",
        supplement: "",
      }
      // 放射能判定
      let radioSentence = {
        icon: "",
        supplement: "",
      }
      // 残留農薬判定
      let racSentence = {
        icon: "",
        supplement: "",
      }
      // 食品添加物判定
      let euSentence = {
        icon: "",
        supplement: "",
      }
      let icon = "";
      let supplement = "";

      // 植物検疫用
      let iconArr = [];
      // let exIcon = "";

      // 植物判定
      if (dataList[i].plan_product_code) {
        body.countryCode = dataList[i].country_code;
        body.productCode = dataList[i].plan_product_code;
        const res = await axios.post("/m_plan_quar/select/packing", body);
        minPackingList = res.data.dataList;
      }
      if (minPackingList.length > 0) {
        for (let j in minPackingList) {
          // packing = 1のデータが存在しないとき
          if (j == 0 && minPackingList[j].packing != 1) {
            icon = planNA.exportability_code;
            supplement = planNA.supplement;
          } else {
            if (dataJudge(minPackingList[j].exportability_code)) {
              icon = minPackingList[j].exportability_code;
              supplement = minPackingList[j].supplement;
            } else {
              icon = planNA.exportability_code;
              supplement = planNA.supplement;
            }
          }

          // 1番目の梱包方法詳細を取得
          if (i == 0) {
            planSentence = {
              icon: icon,
              supplement: supplement,
            }
          }

          // 判定アイコン取得
          iconArr.push(icon);

          // if (plantPriorityJudge(exIcon, icon)) {
          //   exIcon = icon;
          // }
        }

        // 植物検疫用アイコン判定
        // if (exIcon) {
        //   planSentence.icon = exIcon;
        // } else {
        //   // アイコンが全て同じか判定
        //   const isAllEqual = array => array.every(value => value === array[0]);
        //   if (isAllEqual(iconArr)) {
        //     planSentence.icon = iconArr[0];
        //   } else {
        //     planSentence.icon = "△";
        //   }
        // }
        // 植物検疫用アイコン判定
        planSentence.icon = PriorityJudgePlantRadio(iconArr);
      } else {
        planSentence = {
          icon: planNA.exportability_code,
          supplement: planNA.supplement,
        }
      }

      // 動物判定
      if (dataList[i].animal_product_code) {
        if (dataJudge(dataList[i].animal_exportability_code)) {
          icon = dataList[i].animal_exportability_code;
          supplement = dataList[i].animal_supplement;
        } else {
          icon = animalNA.exportability_code;
          supplement = animalNA.supplement;
        }
        animalSentence = {
          icon: icon,
          supplement: supplement,
        }
      } else {
        animalSentence = {
          icon: animalNA.exportability_code,
          supplement: animalNA.supplement,
        }
      }
      
      //漁獲証明書判定
      if (dataList[i].marine_exportability_code) {
        if (dataJudge(dataList[i].marine_exportability_code)) {
          icon = dataList[i].marine_exportability_code;
          supplement = dataList[i].marine_supplement;
        } else {
          icon = animalNA.marine_exportability_code;
          supplement = animalNA.marine_supplement;
        }
        marineSentence = {
          icon: icon,
          supplement: supplement,
        }
      } else {
        marineSentence = {
          icon: animalNA.marine_exportability_code,
          supplement: animalNA.marine_supplement,
        }
      }

      // 放射能判定
      if (dataList[i].product_name) {
        radioDataList = await getRadioData(dataList[i].country_code, dataList[i].product_name);
      }
      if (radioDataList.length > 0) {
        let iconRadArr = [];

        for (let j in radioDataList) {
          if (dataJudge(radioDataList[j].exportability_code)) {
            icon = radioDataList[j].exportability_code;
            supplement = radioDataList[j].supplement;
          } else {
            //　国別NAデータ取得
            body = { authKey: API.API_KEY };
            body.productCode = "NA";
            body.countryCode = dataList[i].country_code;
            let res = await axios.post("/m_radio_active_product/select/radio", body);
            if (res.data.dataList.length > 0) {
              let specifyRadioNA = res.data.dataList[0];
              icon = specifyRadioNA.exportability_code;
              supplement = specifyRadioNA.supplement;
            } else {
              icon = radioNA.exportability_code;
              supplement = radioNA.supplement;
            }
          }
          if (priorityJudge(radioSentence.icon, icon)) {
            radioSentence = {
              icon: icon,
              supplement: supplement,
            }
          }

          // 判定アイコン取得
          iconRadArr.push(icon);

        }
        // 放射性物質アイコン判定
        radioSentence.icon = PriorityJudgePlantRadio(iconRadArr);

      } else {
        //　国別NAデータ取得
        body = { authKey: API.API_KEY };
        body.productCode = "NA";
        body.countryCode = dataList[i].country_code;
        let res = await axios.post("/m_radio_active_product/select/radio", body);
        if (res.data.dataList.length > 0) {
          let specifyRadioNA = res.data.dataList[0];
          radioSentence = {
            icon: specifyRadioNA.exportability_code,
            supplement: specifyRadioNA.supplement,
          }
        } else {
          radioSentence = {
            icon: radioNA.exportability_code,
            supplement: radioNA.supplement,
          }
        }
      }

      // 残留農薬判定
      if (dataList[i].rac_product_code) {
        if (dataJudge(dataList[i].rac_exportability_code)) {
          icon = dataList[i].rac_exportability_code;
          supplement = dataList[i].rac_supplement;
        } else {
          icon = racNA.exportability_code;
          supplement = racNA.supplement;
        }
        racSentence = {
          icon: icon,
          supplement: supplement,
        }
      } else {
        racSentence = {
          icon: racNA.exportability_code,
          supplement: racNA.supplement,
        }
      }

      // 食品添加物判定
      if (dataList[i].eu_product_code) {
        if (dataJudge(dataList[i].eu_exportability_code)) {
          icon = dataList[i].eu_exportability_code;
          supplement = dataList[i].eu_supplement;
        } else {
          icon = euNA.exportability_code;
          supplement = euNA.supplement;
        }
        euSentence = {
          icon: icon,
          supplement: supplement,
        }
      } else {
        euSentence = {
          icon: euNA.exportability_code,
          supplement: euNA.supplement,
        }
      }

      // 総合判定(植物or動物)
      if (priorityJudge(planSentence.icon, animalSentence.icon)) {
        compJudgeSentence = {
          icon: animalSentence.icon,
          supplement: animalSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: planSentence.icon,
          supplement: planSentence.supplement,
        }
      }
      // (漁獲証明書)
      if (priorityJudge(compJudgeSentence.icon, marineSentence.icon)) {
        compJudgeSentence = {
          icon: marineSentence.icon,
          supplement: marineSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: compJudgeSentence.icon,
          supplement: compJudgeSentence.supplement,
        }
      }
      // (放射能)
      if (priorityJudge(compJudgeSentence.icon, radioSentence.icon)) {
        compJudgeSentence = {
          icon: radioSentence.icon,
          supplement: radioSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: compJudgeSentence.icon,
          supplement: compJudgeSentence.supplement,
        }
      }
      // (残留農薬)
      if (priorityJudge(compJudgeSentence.icon, racSentence.icon)) {
        compJudgeSentence = {
          icon: racSentence.icon,
          supplement: racSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: compJudgeSentence.icon,
          supplement: compJudgeSentence.supplement,
        }
      }
      // (食品添加物)
      if (priorityJudge(compJudgeSentence.icon, euSentence.icon)) {
        compJudgeSentence = {
          icon: euSentence.icon,
          supplement: euSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: compJudgeSentence.icon,
          supplement: compJudgeSentence.supplement,
        }
      }

      // 総合判定をアイコンファイルと文言に変換
      let result = compIconConversion(compJudgeSentence.icon);

      tableData.push(
        // <tr>
        //   <td className="td1">
        //     {countryName}
        //   </td>
        //   <td className="td2">
        //     {parse(compJudgeSentence.icon + "<br />" + compJudgeSentence.supplement)}
        //   </td>
        // </tr>
        <dl>
          {/* <dt style={{ width: "25%", marginRight: "1px" }}>{productCode}</dt> */}
          <dt style={{ width: "25%" }}>{countryName}</dt>
          <dd style={{ width: "calc(75%)" }}>
            {result}
            {/* <div class="kigou">
              <img src={compJudgeSentence.img} />
            </div>
            <div>{compJudgeSentence.supplement}</div> */}
          </dd>
        </dl>
      );
    }
    return tableData;
  }


  // 判定文言
  // function setJudgeSentence(exportability, supplement) {
  //   if (supplement == null || supplement == "") {
  //     return exportability;
  //   } else {
  //     return exportability + "<br />" + supplement;
  //   }
  // }

  // 放射能用同類データ
  // async function getRadioTypeData(data) {
  //   body.quarType = 3;
  //   body.productCode = data.product_code;
  //   let res = await axios.post("/m_synonym_product/select/type", body);
  //   const radioTypeData = res.data.dataList;
  //   return radioTypeData;
  // }

  // 放射能データ
  async function getRadioData(country_code, product_code) {
    let radioDataList = [];
    body = { authKey: API.API_KEY };
    body.countryCode = country_code;
    body.productCode = product_code;
    let res = await axios.post("/m_radio_active_product/select/radio", body);
    radioDataList = res.data.dataList;
    return radioDataList;
  }

  // 結果画面
  function resultClick(dataList, productName) {
    // ブラウザbackで品目、輸出国が消えるのを防ぐ処理
    navigate("/", { state: { dataList: dataList, productName: productName } });

    return navigate("/D002SearchResult", { state: { dataList: dataList, productName: productName } });
  }

  // 検索処理（輸出可否判定）
  async function searchClick() {
    try {
      setJudge([]);
      console.log(beforeProduct)
      if (autocompleteProduct.length == 0 && beforeProduct == "") {
        return setErrorProduct("※品目を選択してください");
      } else if (autocompleteProduct.length > 1 || (autocompleteProduct.length == 1 && beforeProduct != "")) {
        return setErrorProduct("※品目は1つのみ選択してください");
      } else {
        setErrorProduct("");
      }

      // 選択か手入力かチェック
      let selectProduct = "";
      if (autocompleteProduct.length == 1) {
        selectProduct = autocompleteProduct[0].product_name;
      } else {
        selectProduct = beforeProduct;
      }

      // キーワード入力がある場合、autocompleteを確定した状態と同様にする処理
      // let CouDataList = [];
      let CouDataList = autocompleteCountry.concat();
      // if (autocompleteCountry.length == 0 && beforeCountry != "") {
      if (beforeCountry != "") {
        body = { authKey: API.API_KEY };
        body.countryName = beforeCountry;
        const res = await axios.post("/m_synonym_country/select/single", body);
        if (res.data.dataList.length > 0) {
          // CouDataList = res.data.dataList;
          CouDataList.push(res.data.dataList[0]);
        } else {
          // CouDataList = [{ country_name: beforeCountry, country_code: "" }];
          CouDataList.push({ country_name: beforeCountry, country_code: "" });
        }
        // } else {
        //   CouDataList = autocompleteCountry;
      }

      const kensakuList = [];
      kensakuList.push([{ product_name: selectProduct, product_code: selectProduct }]);
      kensakuList.push(CouDataList);
      let arrStr = JSON.stringify(kensakuList);
      // 検索
      body = { authKey: API.API_KEY };
      body.arrStr = arrStr;
      // グローバルIP取得
      let ip;
      try {
        await axios.get("https://ipinfo.io").then(res => ip = res.data.ip);
      } catch {
        ip = null;
      }

      // 検索履歴作成
      if (ip) {
        body.ipAddr = ip;
      }

      body.pageName = "輸出判定";
      await axios.post("/t_search_his/insert", body);

      // 品目名から複数の品目コードを取得
      body.productName = selectProduct;
      let res = await axios.post("/m_synonym_product/select/product", body);
      const synProDataList = res.data.dataList;
      console.log(synProDataList)
      if (synProDataList.length == 0) {
        let judgeMsg = "「品目：" + selectProduct + "」の該当データが見つかりませんでした。";
        setJudge([<><p class="judge">{judgeMsg}</p><p>{note}</p></>]);
      } else if (synProDataList.length > 1) {
        let radio = [];
        for (let i in synProDataList) {
          let id = "radio" + i;
          radio.push(
            <>
              <input
                type="radio"
                id={id}
                name="demo"
                onClick={() => radioClick([{ product_name: synProDataList[i].product_name, product_code: synProDataList[i].product_code }])}
              />
              <label for={id} style={{ marginLeft: "5px" }}>{synProDataList[i].product_code}</label>
            </>
          );
        }

        setSynProDataList(
          <>
            <div class="checkTextBox">
              <p>以下に類似品目があります。こちらではありませんか？</p>
            </div>
            <div class="checkRadioBtns" >
              {radio}
            </div>
            <div class="checkDetailBtn"><a onClick={() => reSearchClick()}>チェックした品目で再度判定</a></div>
          </>
        );
      } else {
        setSynProDataList([]);
        judgeExportability(synProDataList, CouDataList, selectProduct);
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  // ラジオボタンクリック時
  function radioClick(radioData) {
    synProData = radioData;
  }

  // 検索処理（輸出可否判定）
  async function reSearchClick() {
    console.log(synProData);

    if (synProData.length == 0) {
      return;
    }

    // キーワード入力がある場合、autocompleteを確定した状態と同様にする処理
    let CouDataList = autocompleteCountry.concat();
    if (beforeCountry != "") {
      body = { authKey: API.API_KEY };
      body.countryName = beforeCountry;
      const res = await axios.post("/m_synonym_country/select/single", body);
      if (res.data.dataList.length > 0) {
        CouDataList.push(res.data.dataList[0]);
      } else {
        CouDataList.push({ country_name: beforeCountry, country_code: "" });
      }
    }

    await judgeExportability(synProData, CouDataList, synProData[0].product_name);
    setSynProDataList([]);
  }

  // 輸出可否判定処理
  async function judgeExportability(productList, countryList, productName) {
    try {
      // Loading
      setIsLoading(true);

      let judgeDataList = []; // 検索品目リスト
      let judgeDataWork = []; // work 同類品目リスト
      let res = [];

      let kensakuList = [];
      kensakuList.push(productList);
      kensakuList.push(countryList);
      let arrStr = JSON.stringify(kensakuList);
      body.arrStr = arrStr;
      res = await axios.post("/m_export_country/select/judge", body);
      judgeDataList = res.data.judgeDataList;
      judgeDataWork = res.data.judgeDataWork;

      // 検索品目
      for (let i in judgeDataList) {
        for (let j in judgeDataWork) {
          // 植物検疫
          if (judgeDataList[i]["plan_product_code"] == null
            && judgeDataWork[j]["plan_product_code"] != null) {
            judgeDataList[i]["plan_product_code"] = judgeDataWork[j]["plan_product_code"];
          }
          // 動物検疫
          if (judgeDataList[i]["animal_product_code"] == null
            && judgeDataWork[j]["animal_product_code"] != null) {
            judgeDataList[i]["animal_product_code"] = judgeDataWork[j]["animal_product_code"];
            judgeDataList[i]["animal_enable_date"] = judgeDataWork[j]["animal_enable_date"];
            judgeDataList[i]["animal_disable_date"] = judgeDataWork[j]["animal_disable_date"];
            judgeDataList[i]["animal_exportability_code"] = judgeDataWork[j]["animal_exportability_code"];
            judgeDataList[i]["animal_supplement"] = judgeDataWork[j]["animal_supplement"];
            judgeDataList[i]["animal_special_cond"] = judgeDataWork[j]["animal_special_cond"];
            judgeDataList[i]["animal_url"] = judgeDataWork[j]["animal_url"];
            judgeDataList[i]["marine_exportability_code"] = judgeDataWork[j]["marine_exportability_code"];
            judgeDataList[i]["marine_supplement"] = judgeDataWork[j]["marine_supplement"];
            judgeDataList[i]["marine_special_cond"] = judgeDataWork[j]["marine_special_cond"];
            judgeDataList[i]["marine_url"] = judgeDataWork[j]["marine_url"];
          }
          // 放射性規制
          if (judgeDataList[i]["product_name"] == null
            && judgeDataWork[j]["product_name"] != null) {
            judgeDataList[i]["product_name"] = judgeDataWork[j]["product_name"];
          }
          // 残留農薬
          if (judgeDataList[i]["rac_product_code"] == null
            && judgeDataWork[j]["rac_product_code"] != null) {
            judgeDataList[i]["rac_product_code"] = judgeDataWork[j]["rac_product_code"];
            judgeDataList[i]["rac_enable_date"] = judgeDataWork[j]["rac_enable_date"];
            judgeDataList[i]["rac_disable_date"] = judgeDataWork[j]["rac_disable_date"];
            judgeDataList[i]["rac_exportability_code"] = judgeDataWork[j]["rac_exportability_code"];
            judgeDataList[i]["rac_supplement"] = judgeDataWork[j]["rac_supplement"];
            judgeDataList[i]["rac_special_cond"] = judgeDataWork[j]["rac_special_cond"];
            judgeDataList[i]["rac_url"] = judgeDataWork[j]["rac_url"];
          }
          // 食品添加物
          if (judgeDataList[i]["eu_product_code"] == null
            && judgeDataWork[j]["eu_product_code"] != null) {
            judgeDataList[i]["eu_product_code"] = judgeDataWork[j]["eu_product_code"];
            judgeDataList[i]["eu_enable_date"] = judgeDataWork[j]["eu_enable_date"];
            judgeDataList[i]["eu_disable_date"] = judgeDataWork[j]["eu_disable_date"];
            judgeDataList[i]["eu_exportability_code"] = judgeDataWork[j]["eu_exportability_code"];
            judgeDataList[i]["eu_supplement"] = judgeDataWork[j]["eu_supplement"];
            judgeDataList[i]["eu_special_cond"] = judgeDataWork[j]["eu_special_cond"];
            judgeDataList[i]["eu_url"] = judgeDataWork[j]["eu_url"];
          }
        }
      }

      let planNA;
      let animalNA;
      let radioNA;
      let racNA;
      let euNA;
      let planNADataList = [];
      let animalNADataList = [];
      let radioNADataList = [];
      let racNADataList = [];
      let euNADataList = [];
      // 植物検疫もしくは動物検疫のNAデータ取得
      body.code = "NA";
      // 植物用NAデータ取得
      res = await axios.post("/m_plan_quar/select", body);
      planNADataList = res.data.dataList;
      // 動物用NAデータ取得
      res = await axios.post("/m_animal_quar/select", body);
      animalNADataList = res.data.dataList;
      // 放射能用NAデータ取得
      res = await axios.post("/m_radio_active/select", body);
      radioNADataList = res.data.dataList;
      // 残留農薬用NAデータ取得
      res = await axios.post("/m_rac_quar/select", body);
      racNADataList = res.data.dataList;
      // 食品添加物用NAデータ取得
      res = await axios.post("/m_eu_quar/select", body);
      euNADataList = res.data.dataList;

      if (
        planNADataList.length > 0
        && animalNADataList.length > 0
        && radioNADataList.length > 0
        && racNADataList.length > 0
        && euNADataList.length > 0
      ) {
        planNA = planNADataList[0];
        animalNA = animalNADataList[0];
        radioNA = radioNADataList[0];
        racNA = racNADataList[0];
        euNA = euNADataList[0];
      } else {
        return setMsg("NAデータが存在しません。管理者にお問い合わせください。");
      }

      // if (judgeDataList.length == 0) {
      // let haiQueList = [];
      let judgeMsg = "";
      // -or?データ取得
      // body.code = "";
      // body.productCode = selectProduct[0].product_code;
      // body.haiQue = true;
      // const planHaiQue = await axios.post("/m_plan_quar/select", body);
      // const animalHaiQue = await axios.post("/m_animal_quar/select", body);
      // const radioHaiQue = await axios.post("/m_radio_active_product/select/radio", body);
      // const racHaiQue = await axios.post("/m_rac_quar/select", body);
      // const euHaiQue = await axios.post("/m_eu_quar/select", body);
      // haiQueList = haiQueList.concat(planHaiQue.data.dataList);
      // haiQueList = haiQueList.concat(animalHaiQue.data.dataList);
      // haiQueList = haiQueList.concat(radioHaiQue.data.dataList);
      // haiQueList = haiQueList.concat(racHaiQue.data.dataList);
      // haiQueList = haiQueList.concat(euHaiQue.data.dataList);
      // console.log(haiQueList)
      // if (haiQueList.length > 0) {
      //   if (haiQueList[0].exportability_code == "-") {
      //     judgeMsg = "「品目：" + selectProduct[0].product_code + "」は対象外品目です。";
      //   } else if (haiQueList[0].exportability_code == "?") {
      //     judgeMsg = "「品目：" + selectProduct[0].product_code + "」は判定不可です。";
      //   }
      // } else 
      if (judgeDataList.length == 0) {
        judgeMsg = "「品目：" + productName + "」の該当データが見つかりませんでした。";
        return setJudge([<><p class="judge">{judgeMsg}</p><p>{note}</p></>]);
      }

      // 複数の輸出国の中で検索出来なかった場合、メッセージを表示する
      let msg = [];
      countryList.forEach((countryInfo) => {
        let isHit = false;
        judgeDataList.forEach((judgeDataInfo) => {
          if (countryInfo.country_code == judgeDataInfo.country_code) {
            isHit = true;
          }
        });
        if (isHit == false) {
          msg.push(countryInfo.country_name);
        }
      });
      let judgeMsgContent = [];
      if (msg.length > 0) {
        // return setJudge([<><p class="judge">{judgeMsg}</p><p>{note}</p></>]);
        judgeMsgContent.push(
          <>
            <p class="judge" style={{ marginTop: "10px" }}>
              「輸出先国名：{msg.join("、")}」の該当データが見つかりませんでした。
            </p>
          </>);
      }

      // return setMsg("選択されたデータが存在しません。");
      // }

      await judgeMethod(judgeDataList, productName, planNA, animalNA, radioNA, racNA, euNA, judgeMsgContent);
    } catch (err) {
      console.log(err)
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    } finally {
      setIsLoading(false);
    }
  }

  // よく見られる品目のOpen/Close
  function ProductClick() {
    if (isProductOpen) {
      setIsProductOpen(false);
    } else {
      setIsProductOpen(true);
    }
  }

  // よく見られる輸出先国のOpen/Close
  function CountryClick() {
    if (isCountryOpen) {
      setIsCountryOpen(false);
    } else {
      setIsCountryOpen(true);
    }
  }

  return (
    <>

      <MenuMenu sel={1} />
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              {/* Loading */}
              <Backdrop open={isLoading}
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <CircularProgress />
              </Backdrop>

              <ProductContext.Provider value={selectValue}>

                <dl>
                  <dt>輸出する品目名（1品目）
                    <span class="hissu">必須</span>
                    <a href="./D006FirstTime"><span class="icon">
                      <img src={icon_hatena_gray} alt="" />
                    </span>判定できる品目について</a>
                  </dt>
                  <dd>
                    <div class="button" style={{ margin: "0 0 10px" }}>
                      <ProductDialog />
                    </div>
                    <div class="text">
                      {/* <input type="text" class="formDefault search" placeholder="例）いちご, イネ等キーワード" /> */}
                      <Autocomplete
                        id="product"
                        className="d001_text"
                        multiple // 複数選択
                        value={autocompleteProduct}
                        freeSolo // 開閉をなくす
                        options={productOptions}
                        onInputChange={(e, changeValue) => {
                          productSearchHandler(changeValue);
                        }} // テキスト内容変更時
                        onChange={productChange} // 選択状態変更時
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="例）いちご,ダイコン等キーワード入力"
                            error={Boolean(errorProduct == "" ? false : true)}
                            // Enter無効
                            inputProps={{
                              ...params.inputProps,
                              onKeyDown: (e) => {
                                if (e.key === 'Enter') {
                                  e.stopPropagation();
                                }
                              },
                            }}
                          />
                        )}
                        filterOptions={(options) => options} // オートコンプリートの検索処理をなくす
                        getOptionLabel={(option) => option.product_name}
                      />

                    </div>
                    {/* <p class="error">※品目を入力してください。</p> */}
                    <FormControl error={errorProduct}>
                      <FormHelperText>{errorProduct}</FormHelperText>
                    </FormControl>

                  </dd>
                </dl>
              </ProductContext.Provider>

              <CountryContext.Provider value={selectValue}>
                <dl>
                  <dt>輸出先国名（複数入力可）</dt>
                  <dd>
                    <div class="button" style={{ margin: "0 0 10px" }}>
                      {/* <input type="button" class="buttonDefault" vcheckBtnalue="一覧から選択" /> */}
                      <ExportCountryDialog />
                    </div>
                    <div class="text">
                      {/* <input type="text" class="formDefault search" placeholder="例）台湾、アメリカ等キーワード入力" /> */}
                      <Autocomplete
                        id="country"
                        className="d001_text"
                        value={autocompleteCountry}
                        multiple // 複数選択
                        freeSolo // 開閉をなくす
                        options={countryOptions}
                        onInputChange={(e, changeValue) => {
                          countrySearchHandler(changeValue);
                        }} // テキスト内容変更時
                        onChange={countryChange} // 選択状態変更時
                        renderTags={(tagValue, getTagProps) =>
                          tagValue.map((option, index) => (
                            <Chip
                              label={option.country_name}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="例）台湾,アメリカ等キーワード入力"
                            // Enter無効
                            inputProps={{
                              ...params.inputProps,
                              onKeyDown: (e) => {
                                if (e.key === 'Enter') {
                                  e.stopPropagation();
                                }
                              },
                            }}
                          />
                        )}
                        filterOptions={(options) => options} // オートコンプリートの検索処理をなくす
                        getOptionLabel={(option) => option.country_name}
                      />

                    </div>
                  </dd>
                </dl>
              </CountryContext.Provider>
            </div>

            <div class="checkBtnWrap">
              <input type="button" onClick={() => searchClick()}
                // class="buttonDefault checkBtn " value="輸出可否判定"></input>
                class="buttonDefault checkBtn " value="簡易輸出判定"></input>
                <br />
            </div>
            <div className="checkResultWrap" style={{ textAlign: "center" }}>
              {judge}
              {synProDataList}
            </div>

            <div style={{
              backgroundColor: "#FBECEB"
              , padding: "20px 30px 20px 30px"
              , marginTop: "20px"
            }}>
              <div style={{ color: "red", fontSize: "11", display: "flex" }}>
                <img src={icon_bikkuri} style={{ width: "20px" }} />
                <div style={{ fontWeight: "700", marginLeft: "10px" }}>免責事項</div>
              </div>
              各国・地域の要件・規制は事前の周知なく変更されることがあり、
              本サイトに掲載している情報と異なっている場合があります。
              実際に輸出される際は、輸出先国・地域の輸入事業者を通じて最新の情報をご確認ください。
              <br /><br />
              本サイトの掲載情報の正確性については万全を期しておりますが、
              農林⽔産省は利⽤者が本サイトの情報を⽤いて⾏う⼀切の⾏為について何ら責任を負うものではありません。
              <br /><br />
              本サイトは輸出の一次的検討をする際の参考としてください。輸出にあたっては相手国の一次情報を確認し相手国の輸入業者と相談するようにしてください。
            </div>

          </div>

          <div class="popularItemWrap">
            <div class="popularItem">
              <p class="h2En">FEATURED ITEM</p>
              <h2>よく見られている品目</h2>
              <div class="popularItemList">
                <ul>
                  {seenProductList}
                </ul>
                <div style={isProductOpen ? { display: "block" } : { display: "none" }}>
                  <ul>
                    {hideProductList}
                  </ul>
                </div>
                <span class={isProductOpen ? "openTrigger isOpen" : "openTrigger"} onClick={() => ProductClick()}></span>
              </div>
            </div>
            <div class="popularItem">
              <p class="h2En">DESTINATION COUNTRY </p>
              <h2>よく見られている輸出先国</h2>
              <div class="popularItemList">
                <ul>
                  {seenCountryList}
                </ul>
                <div style={isCountryOpen ? { display: "block" } : { display: "none" }}>
                  <ul>
                    {hideCountryList}
                  </ul>
                </div>
                <span class={isCountryOpen ? "openTrigger isOpen" : "openTrigger"} onClick={() => CountryClick()}></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default D001SearchTop;